module.exports = __webpack_public_path__ + "img/news_company.26adf53d.png";